import * as React from "react";
import { SVGProps, memo } from "react";

const SvgMedicalExamination = (props: SVGProps<SVGSVGElement>) => (
  <svg width={64} height={64} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.293 16.622a.414.414 0 0 0-.414.413v9.096c0 2.654 2.175 4.828 4.828 4.828h4.76c2.653 0 4.827-2.174 4.827-4.828v-9.095a.414.414 0 0 0-.414-.414h-1.884v-1.38h1.884c.991 0 1.794.804 1.794 1.794v9.095c0 3.416-2.792 6.208-6.208 6.208h-4.759c-3.415 0-6.207-2.792-6.207-6.208v-9.096c0-.99.803-1.793 1.793-1.793h1.653v1.38h-1.653Z"
      fill="#194D33"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.236 40.009V30.75h1.38v9.259c0 5.492-4.492 9.986-9.988 9.986-5.691 0-10.345-4.653-10.345-10.345v-8.072h1.38v8.072c0 4.93 4.035 8.966 8.965 8.966 4.734 0 8.608-3.876 8.608-8.607Z"
      fill="#194D33"
    />

    <path d="M42.95 37.453a4.414 4.414 0 1 0 0-8.828 4.414 4.414 0 0 0 0 8.828Z" fill="#4DB27F" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.95 29.317a3.724 3.724 0 1 0 0 7.449 3.724 3.724 0 0 0 0-7.45Zm-5.104 3.724a5.104 5.104 0 1 1 10.208 0 5.104 5.104 0 0 1-10.208 0Z"
      fill="#194D33"
    />

    <path d="M42.95 35.242a2.207 2.207 0 1 0 0-4.414 2.207 2.207 0 0 0 0 4.414Z" fill="#8CD9B2" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.95 31.385a1.655 1.655 0 1 0 0 3.31 1.655 1.655 0 0 0 0-3.31Zm-2.759 1.655a2.759 2.759 0 1 1 5.518 0 2.759 2.759 0 0 1-5.518 0Z"
      fill="#194D33"
    />

    <path
      d="M21.875 15.688a1.687 1.687 0 1 1-3.375 0 1.687 1.687 0 0 1 3.375 0ZM29.44 15.688a1.688 1.688 0 1 1-3.376 0 1.688 1.688 0 0 1 3.375 0Z"
      fill="#194D33"
    />
  </svg>
);

const Memo = memo(SvgMedicalExamination);

export default Memo;
